export const config = {
  title: "Montriva AI Solutions | AI & Business Technology in Clayton, MO",
  meta: {
    description:
      "Montriva AI Solutions provides advanced AI-driven technology and business solutions in Clayton, MO. We specialize in AI consulting, automation, data analytics, and digital transformation services.",
    keywords: [
      "Montriva AI Solutions",
      "AI consulting Clayton MO",
      "artificial intelligence services",
      "business automation",
      "data analytics",
      "digital transformation",
      "AI-driven solutions"
    ],
    author: "Montriva AI Solutions",
    canonicalUrl: "https://mybizsolutions.us/biz/montriva-ai-solutions",
  },
  sections: {
    header: {
      businessName: "Montriva AI Solutions",
    },
    sectionB: {
      heroTitle: "AI-Powered Business Transformation",
      heroSubtitle: "Innovative AI Solutions to Drive Growth and Efficiency",
      learnAboutText: "Discover Our Services",
      phoneNumber: "3143252531",
      phoneLabel: "314-325-2531",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2220733208/photo/big-data-analytics-abstract-visualization.jpg?s=612x612&w=0&k=20&c=XiX7IAcwscImLbRU2nLDn4vyPxibCqNWXnOjHE-7c7g=",
      cardData: [
        {
          title: "AI Consulting",
          description:
            "Tailored artificial intelligence strategies to fit your business needs.",
        },
        {
          title: "Automation",
          description:
            "Streamline processes and improve productivity with AI-driven automation.",
        },
        {
          title: "Data Analytics",
          description:
            "Transform raw data into actionable insights with advanced analytics tools.",
        },
      ],
      description:
        "At Montriva AI Solutions, we harness the power of artificial intelligence to help businesses embrace the future of technology. From automation and consulting to data-driven insights, our goal is to transform how organizations work and grow.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Explore our AI-driven services designed to modernize and empower your business.",
      cards: [
        {
          title: "AI Consulting",
          description:
            "Develop strategic AI roadmaps tailored to your industry and business goals.",
          imageSrc: "https://media.istockphoto.com/id/2186780950/photo/software-engineers-collaborating-on-a-project-analyzing-code-on-computer-monitors-in-office.jpg?s=612x612&w=0&k=20&c=IjEpYeHTtR_RV7P0OJrgHF-2dIyRkxBu2xcPw9OsP2c=",
          imageAlt: "AI Consulting",
        },
        {
          title: "Business Automation",
          description:
            "Optimize workflows and reduce costs with intelligent automation solutions.",
          imageSrc: "https://media.istockphoto.com/id/2161721546/photo/smart-industry-control-concept.jpg?s=612x612&w=0&k=20&c=bnnOu71qWCVNgL6bqiaN_TyT-XzqE9Re40T853g1NK0=",
          imageAlt: "Business Automation",
        },
        {
          title: "Data Analytics & Insights",
          description:
            "Leverage AI-powered tools to make smarter, data-driven decisions.",
          imageSrc: "https://media.istockphoto.com/id/2161896296/photo/businesswoman-analyzing-financial-data-on-a-digital-tablet.jpg?s=612x612&w=0&k=20&c=4ALi6xxcNClwuLp1kih_SxAOB9ddHBil9e2Y1_LnwUg=",
          imageAlt: "Data Analytics",
        },
      ],
      otherServicesTitle: "Other Services",
      otherServicesList: [
        "Digital Transformation",
        "Machine Learning Integration",
        "Custom AI Development",
        "Business Intelligence",
      ],
    },
    sectionD: {
      aboutTitle: "About Montriva AI Solutions",
      aboutImage: {
        src: "https://media.istockphoto.com/id/2224192315/photo/closeup-of-young-asian-man-working-from-home-using-digital-tablet-for-financial-data-analysis.jpg?s=612x612&w=0&k=20&c=cokCJ71zKS73ImFX1ugbgJ3fVScVXtHzRc04B3MfWrs=",
        alt: "Montriva AI Solutions Team",
      },
      aboutText: [
        "Montriva AI Solutions is a technology-forward company based in Clayton, MO, focused on helping organizations harness the power of AI.",
        "Our mission is to empower businesses to adopt innovative solutions, improve efficiency, and achieve sustainable growth in the digital era.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Montriva AI Solutions Logo",
      businessName: "Montriva AI Solutions",
      contact: {
        phone: "3143252531",
        phoneLabel: "314-325-2531",
        email: "info@montrivaaisolutionsllc.com",
        website: "https://mybizsolutions.us/biz/montriva-ai-solutions",
        address: "231 S Bemiston Ave #850, Clayton, MO 63105",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedIn: null,
        youtube: null,
        tiktok: null,
      },
    },
    sectionF: {
      address: "231 S Bemiston Ave #850, Clayton, MO 63105",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3085.657!2d-90.338!3d38.649!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87d8c9389a5f3b2b%3A0xabcdef123456789!2s231%20S%20Bemiston%20Ave%20%23850%2C%20Clayton%2C%20MO%2063105!5e0!3m2!1sen!2sus!4v1714567890123!5m2!1sen!2sus",
    },
  },
};

export default config;
